/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useState } from "react";
import {
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  Cancel,
  Check,
  CheckCircle,
  Close,
  MoreVert,
  Search,
  SearchOutlined,
} from "@material-ui/icons";
import moment from "moment";
import {
  ActionButton,
  CustomButton,
  CustomIconButton,
  FilterChip,
  MobileMoreMenu,
  MobileMoreMenuItem,
  PackageBadge,
  PageWrapper,
  SearchContainer,
  StatusIconBadge,
  StatusPill,
  TabbleStatusBox,
} from "../assets/styled";
import Table from "../components/Table";
import * as thunks from "../store/thunks";
import { Edit, Plus } from "../assets/icons";
import NewUser from "../components/modals/NewUser";
import AssignPackage from "../components/modals/AssignPackage";
import PhonelinkSetupIcon from "@material-ui/icons/PhonelinkSetup";
import SettingsCellIcon from "@material-ui/icons/SettingsCell";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import { Colors } from "../assets/statics";
import UserActivitiesModal from "../components/modals/UserActivitiesModal";

const filterButtons = [
  { id: 1, text: "Tümü", type: "ALL" },
  { id: 2, text: "Aktif Paketi Olanlar", type: "HAVE_PACK" },
  { id: 3, text: "Paketi Olmayanlar", type: "NO_PACK" },
  { id: 3, text: "Aktivasyon Yapmış", type: "ACTIVATED" },
];

function Users() {
  const [state, setState] = React.useState({
    // searchFilter: '',
  });
  const [searchFilter, setSearchFilter] = useState("");
  const [activeFilter, setActiveFilter] = useState(["ALL"]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [openUserModal, setOpenUserModal] = useState(false);
  const [openAssignPackageModal, setOpenAssignPackageModal] = useState(false);
  const [openActivitiesModal, setOpenActivitiesModal] = useState(false);
  const [edit, setEdit] = useState(false);

  // Redux Store Verisi çağırma
  const allUsers = useSelector((state1) => state1.allUsers);

  // Action Listesi
  const dispatch = useDispatch();

  const deleteUser = useCallback(
    () => dispatch(thunks.deleteUser(selectedUserId)),
    [dispatch, selectedUserId],
  );
  const searchUser = useCallback(
    (search) => dispatch(thunks.searchUser(search)),
    [dispatch],
  );
  const userDevices = useCallback(
    (type, user) => dispatch(thunks.userDevices({ type, user })),
    [dispatch],
  );

  // Fonksiyon Direkt Çalışacaksa
  useEffect(() => {
    dispatch(thunks.getUser());
    dispatch(thunks.getPackage());
  }, [dispatch]);

  const columns = [
    {
      name: "is_removed",
      text: "Durumu",
      filterable: true,
      editable: false,
      align: "left",
      sortable: false,
      type: "text",
      customBody: (value) => (
        <StatusPill isActive={!value}>{value ? "Pasif" : "Aktif"}</StatusPill>
      ),
    },
    {
      name: "id",
      text: "Id",
      filterable: true,
      editable: false,
      align: "center",
      sortable: false,
      type: "text",
      downloadable: true,
    },
    {
      name: "name",
      text: "İsim",
      filterable: false,
      editable: false,
      align: "left",
      sortable: false,
      type: "text",
      downloadable: true,
    },
    {
      name: "mail",
      text: "Mail",
      filterable: false,
      editable: false,
      align: "left",
      sortable: false,
      type: "text",
      downloadable: true,
    },
    {
      name: "provider",
      text: "Provider",
      filterable: false,
      editable: false,
      align: "left",
      sortable: false,
      type: "text",
      downloadable: true,
      customBody: (value) => {
        switch (value) {
          case "google":
            return "Google";
          case "apple":
            return "Apple";
          default:
            return "Email";
        }
      },
    },
    {
      name: "createdAt",
      text: "Tarih",
      filterable: false,
      editable: false,
      align: "left",
      sortable: false,
      type: "text",
      downloadable: true,
      customBody: (value) => moment(value).format("DD.MM.YYYY"),
    },
    {
      name: "Devices",
      text: "Cihaz",
      filterable: false,
      editable: false,
      align: "center",
      sortable: false,
      type: "text",
      customBody: (value) =>
        value ? (
          <div>
            {value.devices.length} / {value.deviceCount}
          </div>
        ) : (
          "-"
        ),
    },
    {
      name: "app_version",
      text: "Versiyon",
      filterable: false,
      editable: false,
      align: "center",
      sortable: false,
      type: "text",
    },
    {
      name: "Package",
      text: "Geçerli Paketleri",
      filterable: false,
      editable: false,
      align: "left",
      sortable: false,
      type: "text",
      customBody: (value) => (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {value.map((item, index) => {
            const isExpired = moment(item.UserPackages.end_date).isBefore(
              moment(),
            );
            const formattedDate = moment(item.UserPackages.end_date).format(
              "DD.MM.YYYY",
            );

            return (
              <Tooltip
                key={index}
                placement="top"
                title={`Bitiş: ${formattedDate}`}
                arrow
              >
                <PackageBadge isExpired={isExpired}>{item.name}</PackageBadge>
              </Tooltip>
            );
          })}
        </div>
      ),
    },
    {
      name: "activationCode",
      text: "Kod",
      filterable: false,
      editable: false,
      align: "left",
      sortable: false,
      type: "text",
    },
    {
      name: "is_activated",
      text: "Aktivasyon",
      filterable: false,
      editable: false,
      align: "left",
      sortable: false,
      type: "text",
      downloadable: true,
      customBody: (value) => (
        <StatusIconBadge isSuccess={!!value}>
          {value ? <Check /> : <Close />}
        </StatusIconBadge>
      ),
    },
    {
      name: "Action",
      text: "İşlemler", // Başlığı türkçeleştirdik
      filterable: false,
      editable: false,
      align: "center",
      sortable: false,
      type: "action",
      disableSetting: true, // Ayarlardan kapatılmasın
      customBody: (value, columnName, index, row) => {
        // Menü açık mı kontrolü
        const isOpen = Boolean(state[`anchorMobileTable${row.id}`]);

        return (
          <div
            key={`action-${row.id}`}
            onClick={(e) => e.stopPropagation()} // Satır tıklamasını tamamen izole et
            style={{ display: "flex", justifyContent: "center" }}
          >
            <IconButton
              aria-label="more"
              aria-controls={`menu-${row.id}`}
              aria-haspopup="true"
              onClick={(e) => {
                e.stopPropagation();
                setState({ [`anchorMobileTable${row.id}`]: e.currentTarget });
                setSelectedUserId(row.id);
              }}
              style={{
                backgroundColor: isOpen
                  ? "rgba(0, 242, 255, 0.1)"
                  : "transparent",
                borderRadius: "10px",
              }}
            >
              <MoreVert
                style={{ color: isOpen ? "#00F2FF" : Colors.darkWhite }}
              />
            </IconButton>

            <MobileMoreMenu
              id={`menu-${row.id}`}
              anchorEl={state[`anchorMobileTable${row.id}`]}
              keepMounted
              open={isOpen}
              onClose={() => {
                setState({ [`anchorMobileTable${row.id}`]: null });
                setSelectedUserId(null);
                setEdit(false);
              }}
              // Mobilde menünün doğru yerde açılması için kritik ayarlar
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              disablePortal={false} // Menüyü DOM dışına çıkararak overflow sorunlarını çözer
            >
              <MobileMoreMenuItem
                onClick={() => {
                  setState({ [`anchorMobileTable${row.id}`]: null });
                  setEdit(true);
                  setOpenUserModal(true);
                }}
              >
                <Edit style={{ color: "#00F2FF", fontSize: 20 }} />
                <span>Kullanıcıyı Düzenle</span>
              </MobileMoreMenuItem>

              <MobileMoreMenuItem
                onClick={() => {
                  setState({ [`anchorMobileTable${row.id}`]: null });
                  setOpenActivitiesModal(true);
                }}
              >
                <FormatListBulletedIcon style={{ color: "#00E5FF", fontSize: 20 }} />
                <span>Aktiviteler</span>
              </MobileMoreMenuItem>

              <MobileMoreMenuItem
                onClick={() => {
                  deleteUser();
                  setState({
                    infoDeleteModal: true,
                    [`anchorMobileTable${row.id}`]: null,
                  });
                }}
              >
                {row.is_removed ? (
                  <CheckCircle style={{ color: "#00FF85", fontSize: 20 }} />
                ) : (
                  <Cancel style={{ color: "#FF4C4C", fontSize: 20 }} />
                )}
                <span>{row.is_removed ? "Aktif Yap" : "Pasif Yap"}</span>
              </MobileMoreMenuItem>

              <div
                style={{
                  height: "1px",
                  background: "rgba(255,255,255,0.05)",
                  margin: "4px 0",
                }}
              />

              <MobileMoreMenuItem
                onClick={() => {
                  userDevices("RESET", row.id);
                  setState({ [`anchorMobileTable${row.id}`]: null });
                }}
              >
                <PhonelinkSetupIcon style={{ opacity: 0.7, fontSize: 20 }} />
                <span>Cihazları Sıfırla</span>
              </MobileMoreMenuItem>

              <MobileMoreMenuItem
                onClick={() => {
                  userDevices("ADD", row.id);
                  setState({ [`anchorMobileTable${row.id}`]: null });
                }}
              >
                <SettingsCellIcon style={{ opacity: 0.7, fontSize: 20 }} />
                <span>Cihaz Ekle</span>
              </MobileMoreMenuItem>
            </MobileMoreMenu>
          </div>
        );
      },
    },
  ];

  const getData = () => {
    let data = allUsers;
    // data = searchFilter.length > 0 ? data.filter(item => item?.name?.toLocaleLowerCase()?.includes(searchFilter?.toLocaleLowerCase()) || item?.mail?.toLocaleLowerCase()?.includes(searchFilter?.toLocaleLowerCase())) : data;

    let filteredData = [];
    for (let i = 0; i < activeFilter.length; i++) {
      switch (activeFilter[i]) {
        case "ALL":
          break;
        case "HAVE_PACK":
          filteredData = (filteredData.length > 0 ? filteredData : data).filter(
            (item) =>
              item?.Package?.length > 0 &&
              item?.Package.some(
                (s) => moment(s.UserPackages.end_date) > moment(),
              ),
          );
          break;
        case "NO_PACK":
          filteredData = (filteredData.length > 0 ? filteredData : data).filter(
            (item) =>
              item?.Package?.length === 0 ||
              item?.Package.every(
                (s) => moment(s.UserPackages.end_date) < moment(),
              ),
          );
          break;
        case "ACTIVATED":
          filteredData = (filteredData.length > 0 ? filteredData : data).filter(
            (item) => item?.is_activated,
          );
          break;
        default:
          break;
      }
    }
    data = filteredData.length > 0 ? filteredData : data;
    data = data?.sort?.((a, b) => b.id - a.id);
    return data || [];
  };

  const getSearchData = () => {
    if (searchFilter.length > 2) {
      searchUser(searchFilter);
    }
  };

  return (
    <PageWrapper>
      <Grid container spacing="3">
        {/* Arama Alanı */}
        <Grid item lg={12} xs={12}>
          <div
            className="pageHeader"
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <SearchContainer>
              <Search
                style={{ color: "#00F2FF", marginRight: 12, fontSize: 20 }}
              />
              <input
                type="text"
                placeholder="Kullanıcı adı, e-posta veya ID ile ara..."
                value={searchFilter}
                onChange={(e) => setSearchFilter(e.target.value)}
              />
              {searchFilter?.length > 0 && (
                <Close
                  onClick={() => setSearchFilter("")}
                  style={{
                    color: "rgba(255,255,255,0.3)",
                    cursor: "pointer",
                    marginRight: 10,
                    fontSize: 18,
                  }}
                />
              )}
              <ActionButton active onClick={() => getSearchData()}>
                <SearchOutlined />
                Ara
              </ActionButton>
            </SearchContainer>
          </div>
        </Grid>

        {/* Filtre Butonları */}
        <Grid item lg={12} xs={12}>
          <div
            className="filterButtons"
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
              padding: "10px 0",
            }}
          >
            {filterButtons.map((item) => (
              <FilterChip
                key={item.type}
                isSelected={activeFilter.includes(item.type)}
                onClick={() => {
                  if (item.type === "ALL") {
                    setActiveFilter(["ALL"]);
                  } else {
                    const filters = activeFilter.filter((s) => s !== "ALL");
                    if (filters.includes(item.type)) {
                      setActiveFilter(
                        filters.filter((s) => s !== item.type).length === 0
                          ? ["ALL"]
                          : filters.filter((s) => s !== item.type),
                      );
                    } else {
                      setActiveFilter([...filters, item.type]);
                    }
                  }
                }}
              >
                {item.text}
              </FilterChip>
            ))}
          </div>
        </Grid>
        <Grid item lg={12} xs={12}>
          <Table
            data={getData()}
            columns={columns || []}
            id="reportsTable"
            downloadable
            options={{
              selectableRows: "none",
              header: {
                visible: true,
                columnSetting: false,
              },
              filter: {
                show: true,
                filters: [],
                // onChange: (state, value, text, type) => console.log(state, value, text, type),
                // drawerChange: () => setState(prevstate => ({ filterDrawer: !prevstate.filterDrawer })),
              },
              pagination: {
                active: true,
                perPage: 20,
              },
            }}
            // rowClick={row => console.log(row)}
            // rowClick={() => window.location.replace('/SuggestionDetail')}
          />
        </Grid>
      </Grid>
      {openUserModal && (
        <NewUser
          open={openUserModal}
          onClose={() => setOpenUserModal(false)}
          edit={edit}
          selectedUserId={selectedUserId}
          userData={
            allUsers?.filter((select) => select?.id === selectedUserId)[0]
          }
        />
      )}
      {openAssignPackageModal && (
        <AssignPackage
          open={openAssignPackageModal}
          onClose={() => setOpenAssignPackageModal(false)}
          selectedUserId={selectedUserId}
          userData={allUsers?.find((select) => select?.id === selectedUserId)}
        />
      )}
      <UserActivitiesModal
        open={openActivitiesModal}
        onClose={() => setOpenActivitiesModal(false)}
        user={allUsers?.find((select) => select?.id === selectedUserId)}
      />
    </PageWrapper>
  );
}

export default Users;
